import { HttpClient } from "@angular/common/http";
import { EventEmitter, Injectable } from "@angular/core";
import { ApiPaginationResponseDataNonNullable } from "app/shared/models/api-response.model";
import { Observable } from "rxjs";
import { AuthService } from "../../base-module/base-service/auth.service";
import { UtilitesService } from "../../base-module/base-service/utilites.service";
import { ParceiroPlanoSaudeModel } from "../model/parceiro-plano-saude.model";

@Injectable()
export class ParceiroPlanoSaudeService {
    public empresaPadrao = new EventEmitter<any>();

    constructor(private authService: AuthService, private _http: HttpClient, public utilitesService: UtilitesService) {}

    /**
     * Parceiro Plano de Saúde por id
     * @param id ID da Parceiro Plano de Saúde
     */
    getById(id: number): Observable<any> {
        return this._http.get(this.utilitesService.urlPrefix + "plano-saude/parceiros/" + id, {
            headers: this.authService.getAuthHeaders(),
        });
    }

    /**
     * Lista de Parceiro Plano de Saúde
     * @param id ID da Parceiro Plano de Saúde
     */
    getAll(params: Record<string, unknown>): Observable<ApiPaginationResponseDataNonNullable<ParceiroPlanoSaudeModel>> {
        const paramHttp = this.utilitesService.formurlencoded(params);
        let env = "";
        if (paramHttp !== null && paramHttp !== "") {
            env = "?" + paramHttp;
        }

        return this._http.get<ApiPaginationResponseDataNonNullable<ParceiroPlanoSaudeModel>>(
            this.utilitesService.urlPrefix + "plano-saude/parceiros" + env,
            {
                headers: this.authService.getAuthHeaders(),
            }
        );
    }

    /**
     * Lista de Parceiro Plano de Saúde
     * @param id ID da Parceiro Plano de Saúde
     */
    search(params: any): Observable<any> {
        const paramHttp = this.utilitesService.formurlencoded(params);
        let env = "";
        if (paramHttp != null && paramHttp != "") {
            env = "?" + paramHttp;
        }

        return this._http.get(this.utilitesService.urlPrefix + "plano-saude/parceiros/search" + env, {
            headers: this.authService.getAuthHeaders(),
        });
    }

    /**
     * Delete de Parceiro Plano de Saúde
     * @param id ID da Parceiro Plano de Saúde
     */
    delete(id: number): Observable<any> {
        return this._http.delete(this.utilitesService.urlPrefix + "plano-saude/parceiros/" + id, {
            headers: this.authService.getAuthHeaders(),
        });
    }

    /**
     * Cadastra Parceiro Plano de Saúde
     * @param params Json Parceiro Plano de Saúde
     */
    create(params: any): Observable<any> {
        return this._http.post(this.utilitesService.urlPrefix + "plano-saude/parceiros", JSON.stringify(params), {
            headers: this.authService.getAuthHeaders(),
        });
    }

    /**
     * Atualiza Parceiro Plano de Saúde
     * @param params Json Parceiro Plano de Saúde
     */
    update(id: number, params: any): Observable<any> {
        return this._http.put(this.utilitesService.urlPrefix + "plano-saude/parceiros/" + id, JSON.stringify(params), {
            headers: this.authService.getAuthHeaders(),
        });
    }
}
